import React from 'react';
import './WelcomeNewOrganization.scss';
import { CloseOutlined } from '@ant-design/icons';
import { t } from 'helpers/i18n';

type WelcomeNewOrganizationProps = {
  onClose: () => void;
};

const WelcomeNewOrganization: React.FC<WelcomeNewOrganizationProps> = (
  props
) => {
  return (
    <div className="welcome-organization-container">
      <div className="welcome-organization-header">
        <h2 className="welcome-text-style">
          {t('project_list_welcome_terra_hello')}
        </h2>
        <CloseOutlined
          className="welcome-close-icon-style"
          onClick={props.onClose}
        />
      </div>
      <div className="welcome-organization-header-placeholder-v2" />
      <div className="welcome-organization-content">
        <p>{t('project_list_welcome_content')}</p>
      </div>
    </div>
  );
};

export default WelcomeNewOrganization;
